import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { withAPIV0ErrorHandling } from '../../../../shared/utils/http-request.utils';
import { API_V2_URL, API_V3_URL } from '../../../../../../../common-lib/src/lib/injection-tokens/url.tokens';
import { Budget } from '../../../../shared/types/budget.interface';


@Injectable(
  { providedIn: 'root' }
)
export class BudgetSettingsDrawerService {
  private readonly actionUrl = inject(API_V2_URL);
  private readonly v3ActionUrl = inject(API_V3_URL);
  private readonly http = inject(HttpClient);
  public getApiPath = '/details_with_cab/';
  public createApiPath = '/create_with_cab/';
  public updateApiPath = '/update_with_cab/';

  getBudgetSettings(id: number): Observable<BudgetSettingsResponse> {
    return withAPIV0ErrorHandling(
      this.http.get<BudgetSettingsResponse>(`${this.actionUrl}budget/${id}${this.getApiPath}`)
    );
  }

  getFabBudgetSettings(id: number): Observable<FABBudgetSettingsResponse> {
    return withAPIV0ErrorHandling(
      this.http.get<FABBudgetSettingsResponse>(`${this.v3ActionUrl}budget/${id}${this.getApiPath}`)
    );
  }

  createBudgetWithCAB(payload: CreateUpdateBudgetPayload, isFAB: boolean = false): Observable<any> {
    const url = isFAB ? `${this.v3ActionUrl}budget${this.createApiPath}` : `${this.actionUrl}budget${this.createApiPath}`;
    return withAPIV0ErrorHandling(
      this.http.post(url, payload)
    );
  }

  updateBudgetWithCAB(id: number, payload: CreateUpdateBudgetPayload, isFAB: boolean = false): Observable<any> {
    const url = isFAB ? `${this.v3ActionUrl}budget/${id}${this.updateApiPath}` : `${this.actionUrl}budget/${id}${this.updateApiPath}`;
    return withAPIV0ErrorHandling(
      this.http.patch(url, payload)
    );
  }
}

export interface BudgetCABFormula {
  crd?: string;
  upd?: string;
  id: number;
  budget: number;
  manage_page_fields: number;
  manage_page_fields__name?: string;
  manage_page_fields__display_order?: number;
  manage_page_fields__key_code?: string;
  name: string;
  display_order: number;
  key_code: string;
}

export interface BudgetSettingsResponse {
  budget: Budget;
  budget_cab_formula: BudgetCABFormula[];
}

export interface FABBudgetSettingsResponse {
  budget: Budget;
  budget_cab_formula: string[];
}

export interface CreateUpdateBudgetPayload {
  name: string;
  owner: number;
  amount: number;
  type: string; // e.g. 'Month'
  budget_from: string; // 'YYYY-MM-DD'
  budget_to: string;   // 'YYYY-MM-DD'
  new_campaigns_programs_structure?: boolean;
  is_forecast_enabled: boolean;
  company: number;
  create_by: number;
  suppress_timeframe_allocations?: boolean;
  manage_page_fields: number[]; // e.g. [1, 3, 4]
  anchor_field?: number; // e.g. 1
}


export interface ManagePageFieldsList{
  id: number;
  name: string;
  display_order: number;
  key_code: string;
  is_default_anchor?: boolean;
}
